<template>
  <div>

    <b-modal id="modal_pic_pedido" title="Selecione uma Promoção" ref="my-modal" size="lg" centered ok-title="Salvar"
      cancel-title="Cancelar" cancel-variant="outline-secondary" @show="resetModal" @hidden="resetModal" @ok="handleOk"
      :ok-disabled="GET_LOADING || impostoLoading || (isTargeted && (!targetedHasSelection || targetedQeUnsupported))"
      :cancel-disabled="GET_LOADING || impostoLoading">
      <b-overlay variant="white" :show="GET_LOADING || impostoLoading" spinner-variant="primary" blur="0" opacity=".75"
        rounded="sm">
        <template #overlay v-if="GET_LOADING">
          <div class="text-center mt-5">
            <feather-icon icon="loader" class="font-large-2"></feather-icon>
            <p id="cancel-label" class="mt-1 font-weight-bolder">
              Aguarde, carregando promoções...
            </p>
          </div>
        </template>
        <template #overlay v-if="impostoLoading">
          <div class="text-center">
            <strong>Calculando impostos...</strong>
            <b-spinner small class="ml-1"></b-spinner>
          </div>
        </template>
        <b-alert v-if="targetedQeUnsupported" show variant="info" class="mb-1">
          Esta oferta usa consumo QE e só pode ser aplicada ao conjunto completo de itens da promoção.
          A seleção direcionada de um único SKU foi desabilitada para evitar inserir outros produtos.
        </b-alert>
        <b-tabs v-model="tabs" content-class="mt-2" justified>
          <b-tab active title="Promoções por cliente" :disabled="GET_LOADING">
            <div>
              <app-collapse accordion type="margin">
                <app-collapse-item v-for="item_cliente in picForDisplay.pic_cliente"
                  :title="formatDate(item_cliente.piciniciovalidade) + ' - ' + formatDate(item_cliente.picterminovalidade)"
                  :key="item_cliente.picid" :idCollapse="`pix-${item_cliente.picid}`" :pic-selected="item_cliente"
                  @check-pic="handleCheckPic($event.picSelected, $event.checked, 'pic_cliente')">
                  <div class="business-items" v-for="item_cliente_pic in item_cliente.ItemsPic">
                    <div class="business-item">
                      <div class="media-list media-bordered">
                        <b-media class="row justify-content-between align-items-center p-0">
                          <template #aside data-col="10">
                            <div class="d-flex flex-column">
                              <div class="d-flex align-items-center">
                                <b-checkbox v-if="item_cliente.RegraConsumo === 'QE'"
                                  :checked="isTargeted ? isTargetedItemChecked(item_cliente_pic) : item_cliente_pic.picid === picSelected.picid" disabled
                                  class="custom-control-primary mr-1"
                                  :id="`check-item-${item_cliente_pic.itemid}-${item_cliente_pic.picid}`"
                                  :name="`check-item-${item_cliente_pic.itemid}-${item_cliente_pic.picid}`"
                                  @change="handleCheckItemPic(item_cliente_pic, $event)" />
                                <b-checkbox v-else class="custom-control-primary mr-1"
                                  :checked="isTargeted ? isTargetedItemChecked(item_cliente_pic) : undefined"
                                  :id="`check-item-${item_cliente_pic.itemid}-${item_cliente_pic.picid}`"
                                  :name="`check-item-${item_cliente_pic.itemid}-${item_cliente_pic.picid}`"
                                  @change="handleCheckItemPic(item_cliente_pic, $event)" />
                                <b-img :src="item_cliente_pic.item_img_principal" blank-color="#ccc" width="64"
                                  alt="placeholder" style="margin-right: 10px;" />
                                <div>
                                  <h4 class="media-heading"> {{ item_cliente_pic.item_descricao }} -
                                    Cod.Ref.({{ item_cliente_pic.referencia }})</h4>
                                  <div class="d-flex align-items-center">
                                    <div class="font-weight-bolder text-success mr-2 d-flex align-items-center">
                                      <span id="R">R$</span><span class="font-weight-bolder display-4">{{
                                        precoExibicaoPic(item_cliente_pic, item_cliente.ItemsPic) | formaPriceNotR$
                                      }}</span>
                                      <div class="font-weight-bolder text-secondary mr-1"
                                        style="text-decoration: line-through;padding-left: 5px">
                                        {{ item_cliente_pic.item_price | formtPriceBr }}
                                      </div>
                                      <b-badge variant="light-danger">
                                        -{{ descontoExibicaoPic(item_cliente_pic, item_cliente.ItemsPic) }}%
                                      </b-badge>
                                      <small v-if="descricaoFaixaPic(item_cliente_pic, item_cliente.ItemsPic)"
                                        class="text-muted ml-1">
                                        {{ descricaoFaixaPic(item_cliente_pic, item_cliente.ItemsPic) }}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </template>
                          <template #default class="d-flex justify-content-end">
                            <div class="item-quantity mt-auto d-flex justify-content-end align-items-center">
                              <span>Qtd: {{ item_cliente_pic.RegraConsumo }}</span>
                              <b-form-spinbutton size="sm" class="ml-75" inline
                                v-model="item_cliente_pic.picitemquantidade"
                                :min="item_cliente.RegraConsumo === 'QE'
                                  ? item_cliente_pic.picitemquantidadesaldo : 1"
                                :max="limiteQuantidadePic(item_cliente, item_cliente_pic)"
                                :disabled="item_cliente.RegraConsumo === 'QE'" />
                            </div>
                          </template>
                        </b-media>
                      </div>
                    </div>
                  </div>
                </app-collapse-item>
              </app-collapse>
            </div>
          </b-tab>
          <b-tab title="Promoções gerais" :disabled="GET_LOADING">
            <div>

              <app-collapse accordion type="margin">
                <app-collapse-item v-for="item_gerais in picForDisplay.pic_genericas"
                  :title="formatDate(item_gerais.piciniciovalidade) + ' - ' + formatDate(item_gerais.picterminovalidade)"
                  :key="item_gerais.picid" :pic-selected="item_gerais" :checked-pic="isTargeted ? targetedPicChecked : item_gerais.checked"
                  @check-pic="handleCheckPic($event.picSelected, $event.checked, 'pic_genericas')">

                  <div class="business-items" v-for="item_gerais_pic in item_gerais.ItemsPic">

                    <div class="business-item">
                      <div class="media-list media-bordered">
                        <b-media class="row justify-content-between align-items-center p-0">
                          <template #aside data-col="10">
                            <div class="d-flex flex-column">
                              <div class="d-flex align-items-center">
                                <b-checkbox v-if="item_gerais.RegraConsumo === 'QE'"
                                  :checked="isTargeted ? isTargetedItemChecked(item_gerais_pic) : item_gerais_pic.picid === picSelected.picid" disabled
                                  class="custom-control-primary mr-1"
                                  :id="`check-item-${item_gerais_pic.itemid}-${item_gerais_pic.picid}`"
                                  :name="`check-item-${item_gerais_pic.itemid}-${item_gerais_pic.picid}`"
                                  @change="handleCheckItemPic(item_gerais_pic, $event)" />
                                <b-checkbox v-else class="custom-control-primary mr-1"
                                  :checked="isTargeted ? isTargetedItemChecked(item_gerais_pic) : undefined"
                                  :id="`check-item-${item_gerais_pic.itemid}-${item_gerais_pic.picid}`"
                                  :name="`check-item-${item_gerais_pic.itemid}-${item_gerais_pic.picid}`"
                                  @change="handleCheckItemPic(item_gerais_pic, $event)" />
                                <b-img :src="item_gerais_pic.item_img_principal" blank-color="#ccc" width="64"
                                  alt="placeholder" style="margin-right: 10px;" />
                                <div>
                                  <h4 class="media-heading"> {{ item_gerais_pic.item_descricao }} -
                                    Cod.Ref.({{ item_gerais_pic.referencia }})</h4>
                                  <div class="d-flex align-items-center">
                                    <div class="font-weight-bolder text-success mr-2 d-flex align-items-center">
                                      <span id="R">R$</span><span class="font-weight-bolder display-4">{{
                                        precoExibicaoPic(item_gerais_pic, item_gerais.ItemsPic) | formaPriceNotR$
                                      }}</span>
                                      <div class="font-weight-bolder text-secondary mr-1"
                                        style="text-decoration: line-through;padding-left: 5px">
                                        {{ item_gerais_pic.item_price | formtPriceBr }}
                                      </div>
                                      <b-badge variant="light-danger">
                                        -{{ descontoExibicaoPic(item_gerais_pic, item_gerais.ItemsPic) }}%
                                      </b-badge>
                                      <small v-if="descricaoFaixaPic(item_gerais_pic, item_gerais.ItemsPic)"
                                        class="text-muted ml-1">
                                        {{ descricaoFaixaPic(item_gerais_pic, item_gerais.ItemsPic) }}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </template>
                          <template #default class="d-flex justify-content-end">
                            <div class="item-quantity mt-auto d-flex justify-content-end align-items-center">
                              <span>Qtd: </span>
                              <b-form-spinbutton v-if="item_gerais.RegraConsumo === 'QE'" size="sm" class="ml-75" inline
                                v-model="item_gerais_pic.picitemquantidade"
                                :min="item_gerais_pic.picitemquantidadesaldo"
                                :max="item_gerais_pic.picitemquantidadesaldo" disabled />
                              <b-form-spinbutton v-else-if="item_gerais.RegraConsumo === 'CS'" size="sm" class="ml-75"
                                inline wrap v-model="item_gerais_pic.picitemquantidade"
                                :max="item_gerais_pic.picitemquantidadesaldo" />
                              <!--                              <b-form-spinbutton-->
                              <!--                                  v-else-->
                              <!--                                  size="sm"-->
                              <!--                                  class="ml-75"-->
                              <!--                                  :state="true"-->
                              <!--                                  inline-->
                              <!--                                  v-model="item_gerais_pic.picitemquantidade"-->
                              <!--                              />-->
                              <b-form-input v-else type="number" class="ml-75"
                                v-model="item_gerais_pic.picitemquantidade"
                                @blur="item_gerais_pic.picitemquantidade = $event.target.value > 0 ? $event.target.value : 1"
                                style="width: 90px;height: 30px" :min="1" />
                              <!--                              <b-input-->
                              <!--                                  v-else-->
                              <!--                                  type="number"-->
                              <!--                                  v-model="item_gerais_pic.picitemquantidade"-->
                              <!--                                  style="width: 110px;height: 35px"-->
                              <!--                              />-->
                            </div>
                          </template>
                        </b-media>
                      </div>
                    </div>
                  </div>
                </app-collapse-item>
              </app-collapse>
            </div>

          </b-tab>
        </b-tabs>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormSelect, BCol, BButton, BTabs, BTab, BCardText, BImg, BOverlay,
} from 'bootstrap-vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItemCheckbox.vue';
import { mapGetters } from 'vuex';
import { formaPriceNotR$, formtPriceBr } from '@core/utils/filter';
import SLSPicService from '@/services/Operacoes/SLSPic.service';
import Swal from 'sweetalert2';
import { calcularImpostosPic } from '@/services/Operacoes/picImpostos';
import { normalizarFaixas, precoPorFaixa } from '@/services/Operacoes/picFaixas';
import ItemStore from '../../store/item.store';

const picService = new SLSPicService();
export default {
  components: {
    BOverlay,
    BImg,
    BButton,
    BModal,
    BCol,
    BFormSelect,
    BTabs,
    BTab,
    BCardText,
    AppCollapse,
    AppCollapseItem,
  },
  data() {
    return {
      operacaoData: null,
      tabs: 0,
      impostoLoading: false,
      picSelected: {
        picid: null,
        piciniciovalidade: null,
        picterminovalidade: null,
        picclienteid: null,
      },
      infoModal: {
        type: null,
        operacao: null,
        data: null,
        itemid: null,
        picid: null,
      },
      itemFilterId: null,
      targetedPic: null,
      targetedItemsPic: [],
    };
  },
  filters: {
    formaPriceNotR$,
    formtPriceBr,
  },
  mounted() {
    this.initializeQuantities();
  },
  methods: {
    formatDate(date) {
      if (typeof date !== 'string' || !date.trim()) return '';
      // Validity is a calendar date: do not shift it through the browser timezone.
      const match = date.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T|\s)/);
      if (!match) return '';
      const [, year, month, day] = match;
      return `${day}/${month}/${year}`;
    },
    initializeQuantities() {
      this.GET_PIC.pic_genericas.forEach((item_gerais) => {
        if (item_gerais.RegraConsumo === 'CS') {
          item_gerais.ItemsPic.forEach((item) => {
            item.picitemquantidade = item.picitemquantidadesaldo;
          });
        }
      });
    },
    picBase(item) {
      const valor = item && item.picitemprecobase != null
        ? item.picitemprecobase
        : item && item.picitemvalorpic;
      const base = Number(valor);
      if (!Number.isFinite(base) || base <= 0) {
        throw new Error('A promoção possui preço base inválido.');
      }
      return base;
    },
    picFaixas(item) {
      return normalizarFaixas(item && item.picitemfaixas != null ? item.picitemfaixas : []);
    },
    mesmaPicItem(a, b) {
      return String(a && a.picid) === String(b && b.picid)
        && String(a && (a.itemid ?? a.item_id)) === String(b && (b.itemid ?? b.item_id));
    },
    quantidadeTotalPicItem(item, items) {
      const grupo = (items || []).filter((outro) => this.mesmaPicItem(item, outro));
      const quantidade = grupo.reduce((total, outro) => total + Number(outro.picitemquantidade || 0), 0);
      if (!Number.isInteger(quantidade) || quantidade < 1) {
        throw new Error('A promoção possui quantidade inválida.');
      }
      return quantidade;
    },
    resultadoFaixaPic(item, items) {
      const quantidade = this.quantidadeTotalPicItem(item, items);
      return precoPorFaixa(this.picBase(item), this.picFaixas(item), quantidade);
    },
    precoExibicaoPic(item, items) {
      const resultado = this.resultadoFaixaPic(item, items);
      if (!Number.isFinite(Number(resultado && resultado.preco)) || Number(resultado.preco) <= 0) {
        throw new Error('Não foi possível calcular o preço da faixa da promoção.');
      }
      return resultado.preco;
    },
    descontoExibicaoPic(item, items) {
      const faixas = this.picFaixas(item);
      return faixas.length > 0
        ? this.resultadoFaixaPic(item, items).desconto
        : (item.porcentagem_desconto ?? 0);
    },
    descricaoFaixaPic(item, items) {
      const faixa = this.resultadoFaixaPic(item, items).faixa;
      if (!faixa) return '';
      const max = faixa.max == null ? '∞' : faixa.max;
      return `Faixa ${faixa.min}-${max}`;
    },
    limiteQuantidadePic(pic, item) {
      if (pic && pic.RegraConsumo === 'QE') return item.picitemquantidadesaldo;
      if (pic && pic.RegraConsumo === 'CS') return item.picitemquantidadesaldo;
      return undefined;
    },
    prepararItensPicParaCalculo(items) {
      return items.map((item) => {
        const grupo = items.filter((outro) => this.mesmaPicItem(item, outro));
        const quantidadeTotal = this.quantidadeTotalPicItem(item, items);
        const resultado = this.resultadoFaixaPic(item, grupo);
        return {
          ...item,
          picitemprecobase: this.picBase(item),
          picitemfaixas: this.picFaixas(item),
          picitemquantidadetotal: quantidadeTotal,
          picitemvalorpic: resultado.preco,
          picitemdesconto: resultado.desconto,
          picitemfaixa: resultado.faixa,
          picitemchave: `${item.picid ?? ''}:${item.itemid ?? ''}:${item.picitemsequencia ?? ''}`,
        };
      });
    },
    impostoParaItem(item, impostos) {
      const chave = `${item.picid ?? ''}:${item.itemid ?? ''}:${item.picitemsequencia ?? ''}`;
      const resultado = impostos.find((imposto) => imposto.picitemchave === chave)
        || impostos.find((imposto) => imposto.picid === item.picid
          && imposto.itemid === item.itemid
          && imposto.picitemsequencia === item.picitemsequencia)
        || impostos.find((imposto) => imposto.itemid === item.itemid);
      if (!resultado || !Number.isFinite(Number(resultado.precoComImposto))
        || Number(resultado.precoComImposto) <= 0) {
        throw new Error(`Não foi possível calcular os impostos do item ${item.itemid}.`);
      }
      return resultado;
    },
    isTargetedItemChecked(item) {
      return this.targetedItemsPic.some(selected => String(selected.picid) === String(item.picid)
        && String(selected.itemid ?? selected.item_id) === String(item.itemid ?? item.item_id)
        && selected.checked);
    },
    handleCheckPic(picSelected, isSelectd, type) {
      if (this.isTargeted) {
        if (this.targetedQeUnsupported) return;
        this.targetedPic = {
          ...(this.targetedPic || picSelected),
          checked: isSelectd,
        };
        this.targetedItemsPic = this.targetedItemsPic.map(item => ({
          ...item,
          checked: isSelectd,
        }));
        return;
      }
      switch (this.infoModal.type) {
        case 'info-pedido':
          this.$store.commit('PicStore/SET_CHECKED_PICK_INFO_PEDIDO', {
            picid: picSelected.picid,
            checked: isSelectd,
            type,
          });
          this.$store.commit('PicStore/UPDATE_CHECKED_ITEM_PIC_SELECTED_INFO_PEDIDO', {
            itemid: this.$store.getters['PicStore/GET_PIC_SELECTED'].ItemsPic[0].itemid,
            checked: true,
          });
          const picChecked = this.$store.getters['PicStore/GET_PIC_SELECTED'];
          this.$store.commit('PicStore/REMOVER_ITEM_PIC_INFO_PEDIDO', {
            picid: picChecked.picid,
            itemid: picChecked.ItemsPic[0].itemid,
          });
          if (isSelectd) {
            this.$store.commit('PicStore/ADD_UPDATE_INFO_PEDIDO_PIC', picChecked);
          } else {
            this.$store.commit('PicStore/REMOVER_EXITENTE_INFO_PEDIDO_PIC', picChecked.picid);
          }
          break;
        case 'operacao-pedido':
          this.$store.commit('PicStore/SET_CHECKED_PICK_OPERACAO_PEDIDO', {
            picid: picSelected.picid,
            checked: isSelectd,
            type,
          });
          this.$store.commit('PicStore/UPDATE_CHECKED_ITEM_PIC_SELECTED_OPERACAO_PEDIDO', {
            itemid: this.$store.getters['PicStore/GET_PIC_SELECTED_OPERACAO'].ItemsPic[0].itemid,
            checked: true,
          });
          const picCheckedOperacao = this.$store.getters['PicStore/GET_PIC_SELECTED_OPERACAO'];
          this.$store.commit('PicStore/REMOVER_ITEM_PIC_OPERACAO_PEDIDO', {
            picid: picCheckedOperacao.picid,
            itemid: picCheckedOperacao.ItemsPic[0].itemid,
          });
          if (isSelectd) {
            this.$store.commit('PicStore/ADD_UPDATE_OPERACAO_PEDIDO_PIC', picCheckedOperacao);
          } else {
            this.$store.commit('PicStore/REMOVER_EXITENTE_OPERACAO_PEDIDO_PIC', picCheckedOperacao.picid);
          }
          break;
      }
    },
    handleCheckItemPic(itemPicSelected, isSelectd) {
      // console.log('itemPicSelected', itemPicSelected)
      // console.log('isSelectd', isSelectd)
      if (this.isTargeted) {
        if (this.targetedQeUnsupported) return;
        this.targetedItemsPic = this.targetedItemsPic.map(item => (
          String(item.picid) === String(itemPicSelected.picid)
            && String(item.itemid ?? item.item_id) === String(itemPicSelected.itemid ?? itemPicSelected.item_id)
            ? { ...item, checked: isSelectd }
            : item
        ));
        this.targetedPic = {
          ...(this.targetedPic || {}),
          checked: this.targetedItemsPic.some(item => item.checked),
        };
        return;
      }
      document.querySelector(`#check-item-${itemPicSelected.itemid}-${itemPicSelected.picid}`).checked = isSelectd;
      switch (this.infoModal.type) {
        case 'info-pedido':
          this.$store.commit('PicStore/UPDATE_CHECKED_ITEM_PIC_SELECTED_INFO_PEDIDO', {
            itemid: itemPicSelected.itemid,
            checked: isSelectd,
          });
          isSelectd ? this.$store.commit('PicStore/ADD_UPDATE_ITEMS_PIC_INFO_PEDIDO', itemPicSelected) : this.$store.commit('PicStore/REMOVER_ITEM_PIC_INFO_PEDIDO', {
            picid: itemPicSelected.picid,
            itemid: itemPicSelected.itemid,
          });
          break;
        case 'operacao-pedido':
          this.$store.commit('PicStore/UPDATE_CHECKED_ITEM_PIC_SELECTED_OPERACAO_PEDIDO', {
            itemid: itemPicSelected.itemid,
            checked: isSelectd,
          });
          isSelectd ? this.$store.commit('PicStore/ADD_UPDATE_ITEMS_PIC_OPERACAO_PEDIDO', itemPicSelected) : this.$store.commit('PicStore/REMOVER_EXITENTE_OPERACAO_PEDIDO_PIC', {
            picid: itemPicSelected.picid,
            itemid: itemPicSelected.itemid,
          });
          break;
      }
    },
    showModal(data) {
      this.infoModal = data;
      this.itemFilterId = data.itemid == null ? null : data.itemid;
      this.targetedPic = null;
      this.targetedItemsPic = [];

      if (data.type === 'operacao-pedido') {
        this.operacaoData = data.data;
      }

      this.$bvModal.show('modal_pic_pedido');
      this.$nextTick(async () => {
        await picService.getPicPedidos()
          .then(() => {
            if (this.isTargeted) {
              const pic = [...this.picForDisplay.pic_cliente, ...this.picForDisplay.pic_genericas][0];
              if (pic) {
                this.targetedPic = {
                  ...pic,
                  ItemsPic: (pic.ItemsPic || []).map(item => ({ ...item, checked: false })),
                  checked: false,
                };
                this.targetedItemsPic = this.targetedPic.ItemsPic;
              }
            }
            if (this.GET_PIC.pic_cliente.length > 0) {
              this.tabs = 0;
              return;
            }
            if (this.GET_PIC.pic_genericas.length > 0) {
              this.tabs = 1;
            }
          })
          .finally(() => {
            // Targeted inline selection is intentionally local; restoring a
            // previously selected full PIC here would check its first SKU
            // and reintroduce unrelated items.
            if (this.isTargeted) return;
            switch (this.infoModal.type) {
              case 'info-pedido':
                if (this.$store.getters['PicStore/GET_PIC_SELECTED'].picid) {
                  this.$store.dispatch('PicStore/checkedPicSelected');
                }
                break;
              case 'operacao-pedido':
                if (this.$store.getters['PicStore/GET_PIC_SELECTED_OPERACAO'].picid) {
                  this.$store.dispatch('PicStore/checkedPicSelectedOperacao');
                }
                break;
            }
          });
      });
    },
    async resetModal() {
      // console.log('resete-modal')
    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (this.impostoLoading) return;
      try {
        await this.savePic();
        this.handleSubmit();
        if (this.isTargeted) {
          this.$root.$emit('pic:items-added', { type: this.infoModal.type });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Promoção não adicionada',
          text: error.message || 'Não foi possível calcular os impostos. Tente novamente.',
        });
      }
      // console.log('ITEM CLIENTE', this.GET_PIC)
    },
    handleSubmit() {
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn');
      });
    },
    async savePic() {
      if (this.itemFilterId != null && this.$store.getters['preferencias/picAtivo'] !== true) {
        throw new Error('PIC está desativada nas Preferências.');
      }
      if (this.isTargeted) {
        if (this.targetedQeUnsupported) {
          throw new Error('A oferta QE exige a promoção completa; não é possível usar apenas este SKU.');
        }
        if (!this.targetedHasSelection) {
          throw new Error('Selecione a oferta PIC antes de salvar.');
        }
        if (!this.targetedPic || !this.targetedItemsPic.some(item => item.checked
          && Number.isInteger(Number(item.picitemquantidade)) && Number(item.picitemquantidade) > 0)) {
          throw new Error('Selecione um item PIC com quantidade válida.');
        }
      }
      switch (this.infoModal.type) {
        case 'info-pedido':
          await this.extrairItensPicInfoPedido();
          break;
        case 'operacao-pedido':
          await this.extrairItensPic();
          break;
      }
    },
    resolverTamanhoCor(tamanho) {
      switch (tamanho) {
        case 'Pequeno':
          return 'p';
        case 'Medio':
          return 'm';
        case 'Grande':
          return 'g';
        case 'Extra Grande':
          return 'xg';
        default:
          return 'p';
      }
    },
    async extrairItensPic() {
      const selectedPic = this.isTargeted
        ? { ...this.targetedPic, ItemsPic: this.targetedItemsPic }
        : this.GET_PIC_SELECTED_OPERACAO;
      if (selectedPic?.ItemsPic && selectedPic.ItemsPic.length > 0) {
        // console.log('ENTREI ID EXTRAIR ITENS PIC')
        const regraConsumo = selectedPic.RegraConsumo || selectedPic.regraConsumo
          || selectedPic.regra_consumo;
        const itemPicSelectedOperacao = regraConsumo === 'QE'
          ? selectedPic.ItemsPic
          : selectedPic.ItemsPic.filter((item) => item.checked);
        const itensParaCalculo = this.prepararItensPicParaCalculo(itemPicSelectedOperacao);

        const impostosCalculados = await this.calcularImpostosParaItensPic(itensParaCalculo);

        let pedidosAgrupados = [];
        // console.log('itemPicSelectedOperacao', itemPicSelectedOperacao)
        itemPicSelectedOperacao.forEach((item) => {
          const itemCalculado = itensParaCalculo.find((calculado) => calculado.picitemchave
            === `${item.picid ?? ''}:${item.itemid ?? ''}:${item.picitemsequencia ?? ''}`);
          const impostoItem = this.impostoParaItem(itemCalculado, impostosCalculados);
          const precoPic = Number(impostoItem.precoUnitario);
          const marca = item.cod_marca;
          const { referencia } = item;
          const Qtde = 0;
          const ValorTotal = 0;

          // console.log(pedidosAgrupados, 'pedidosAgrupados')

          const pedidoExistente = pedidosAgrupados.find((pedido) => pedido.CodMarca === marca
            && pedido.CodReferencia === referencia
            && String(pedido.picid ?? '') === String(item.picid ?? ''));

          // console.log('pedidoExistente', pedidoExistente)

          if (!pedidoExistente) {
            const novoItem = {
              codMarca: item.cod_marca,
              familiaComercialId: item.referencia,
              cdncor: item.cdn_cor,
              cdn_embalagem: item.cdn_embalagem,
              des_cor: item.des_cor,
              cdn_tamanho: item.cdn_tamanho,
              itemId: item.itemid,
              item_descricao: item.item_descricao,
              pedidoItemQuantidade: item.picitemquantidade,
              marca: item.des_marca,
              embalagem: item.des_embalag,
              precoUnitario: precoPic,
              valorTotal: +parseInt(item.picitemquantidade) * precoPic,
              pedidoItemQuantidadeSaldo: item.picitemquantidadesaldo,
              pedidoItemQuantidadeFaturada: '-',
              pedido_item_seq: item.picitemsequencia,
              des_tamanho: this.resolverTamanhoCor(item.des_tamanho),
              referencia: item.referencia,
              des_referencia: item.des_referencia,
              cod_categ: item.cod_categ,
              picid: item.picid,
               regra_pic: regraConsumo,
              saldo: item.picitemquantidadesaldo || 0,
              valor_total: precoPic * Number(item.picitemquantidade),
              precoComImposto: impostoItem.precoComImposto,
              valorTotalComImposto: impostoItem.precoComImposto * item.picitemquantidade,
              baseIcms: impostoItem.baseIcms || 0,
              valorIcms: impostoItem.valorIcms || 0,
              naturezaoperacaoidimposto: impostoItem.naturezaoperacaoidimposto || 0,
              base_icms: impostoItem.baseIcms || 0,
              valor_icms: impostoItem.valorIcms || 0,
              natureza_operacao_id_imposto: impostoItem.naturezaoperacaoidimposto || 0,
              picitemvalorpic: precoPic,
              picitemprecobase: itemCalculado.picitemprecobase,
              picitemfaixas: itemCalculado.picitemfaixas,
              picitemdesconto: impostoItem.desconto,
              picitemfaixa: impostoItem.faixa,
              picitemquantidadetotal: itemCalculado.picitemquantidadetotal,
              picitemchave: itemCalculado.picitemchave,
            };
            const novoPedido = {
              CodMarca: marca,
              DescricaoMarca: item.des_marca,
              CodReferencia: referencia,
              DescricaoReferencia: item.des_referencia,
              CodEmbalagem: item.cdn_embalagem,
              DescricaoEmbalagem: item.des_embalag,
              Qtde,
              PrecoUnitario: precoPic,
              ValorTotal,
              referencia: `${item.referencia} - ${item.des_referencia}`,
              tipoPedido: 'pic',
              picid: item.picid,
              itens: [],
              editar: {
                cod_marca: marca,
                cod_categ: item.cod_categ,
                cod_referencia: item.referencia,
                cod_embalagem: item.cdn_embalagem,
                precoId: item.picid,
              },
            };
            novoPedido.itens.push(novoItem);
            pedidosAgrupados.push(novoPedido);
          } else {
            // console.log('JA EXISTE')
            const novoItem = {
              codMarca: item.cod_marca,
              familiaComercialId: item.referencia,
              cdncor: item.cdn_cor,
              cdn_embalagem: item.cdn_embalagem,
              des_cor: item.des_cor,
              cdn_tamanho: item.cdn_tamanho,
              itemId: item.itemid,
              item_descricao: item.item_descricao,
              pedidoItemQuantidade: item.picitemquantidade,
              marca: item.des_marca,
              embalagem: item.des_embalag,
              precoUnitario: precoPic,
              valorTotal: +parseInt(item.picitemquantidade) * precoPic,
              pedidoItemQuantidadeSaldo: item.picitemquantidadesaldo,
              pedidoItemQuantidadeFaturada: null,
              pedidoitemseq: item.picitemsequencia,
              des_tamanho: this.resolverTamanhoCor(item.des_tamanho),
              referencia: item.referencia,
              des_referencia: item.des_referencia,
              cod_categ: item.cod_categ,
              picid: item.picid,
               regra_pic: regraConsumo,
              precoComImposto: impostoItem.precoComImposto,
              valorTotalComImposto: impostoItem.precoComImposto * item.picitemquantidade,
              baseIcms: impostoItem.baseIcms || 0,
              valorIcms: impostoItem.valorIcms || 0,
              naturezaoperacaoidimposto: impostoItem.naturezaoperacaoidimposto || 0,
              base_icms: impostoItem.baseIcms || 0,
              valor_icms: impostoItem.valorIcms || 0,
              natureza_operacao_id_imposto: impostoItem.naturezaoperacaoidimposto || 0,
              picitemvalorpic: precoPic,
              picitemprecobase: itemCalculado.picitemprecobase,
              picitemfaixas: itemCalculado.picitemfaixas,
              picitemdesconto: impostoItem.desconto,
              picitemfaixa: impostoItem.faixa,
              picitemquantidadetotal: itemCalculado.picitemquantidadetotal,
              picitemchave: itemCalculado.picitemchave,
            };
            pedidoExistente.itens.push(novoItem);
            pedidoExistente.Qtde += item.picitemquantidade;
            pedidoExistente.PrecoUnitario += precoPic;
            pedidoExistente.ValorTotal += precoPic * Number(item.picitemquantidade);
          }
        });

        pedidosAgrupados = pedidosAgrupados.map((pedido) => {
          const Qtde = pedido.itens.reduce((acc, item) => acc + item.pedidoItemQuantidade, 0);
          const ValorTotal = pedido.itens.reduce((acc, item) => acc + (item.pedidoItemQuantidade * item.precoUnitario), 0);
          // console.log('ValorTotal', ValorTotal)
          pedido.ValorTotal = ValorTotal;
          pedido.Qtde = Qtde;
          return pedido;
        });
        // console.log('pedidosAgrupados', pedidosAgrupados)
        await this.$store.dispatch('intensPedido/set_tabela_itens_pic', pedidosAgrupados);
        return pedidosAgrupados;
      }
    },

    async extrairItensPicInfoPedido() {
      const selectedPic = this.isTargeted
        ? { ...this.targetedPic, ItemsPic: this.targetedItemsPic }
        : this.GET_PIC_SELECTED;
      if (selectedPic?.ItemsPic && selectedPic.ItemsPic.length > 0) {
        const regraConsumo = selectedPic.RegraConsumo || selectedPic.regraConsumo
          || selectedPic.regra_consumo;
        const itemPicSelected = regraConsumo === 'QE'
          ? selectedPic.ItemsPic
          : selectedPic.ItemsPic.filter((item) => item.checked);
        // A targeted inline add must price against the cumulative quantity
        // before it is merged into PedidosStore. Otherwise a second add can
        // cross a quantity tier while retaining the first-tier price.
        const itensParaCalculo = this.prepararItensPicParaCalculo(itemPicSelected.map(item => ({
          ...item,
          picitemquantidade: Number(item.picitemquantidade || 0)
            + (this.isTargeted ? this.quantidadeExistentePicItem(item) : 0),
        })));

        const impostosCalculados = await this.calcularImpostosParaItensPic(itensParaCalculo);
        const novosItens = [];

        itemPicSelected.forEach((item) => {
          const itemCalculado = itensParaCalculo.find((calculado) => calculado.picitemchave
            === `${item.picid ?? ''}:${item.itemid ?? ''}:${item.picitemsequencia ?? ''}`);
          const impostoItem = this.impostoParaItem(itemCalculado, impostosCalculados);
          const precoPic = Number(impostoItem.precoUnitario);

          const novoItem = {
            cdn_cor: item.cdn_cor,
            cdn_embalag: item.cdn_embalagem,
            cdn_tamanho: item.cdn_tamanho,
            cod_marca: item.cod_marca,
            des_cor: item.des_cor,
            des_tamanho: this.resolverTamanhoCor(item.des_tamanho),
            embalagem: item.des_embalag,
            familia_comercial_descricao: item.des_referencia,
            familia_comercial_id: item.referencia,
            index: this.$store.getters['PedidosStore/getItemPedido'].length,
            item_descricao: item.item_descricao,
            item_id: item.itemid,
            item_imagem: item.item_img_principal,
            marca: item.des_marca,
            pedido_item_preco_unitario: precoPic,
            pedido_item_preco_unitario_base: itemCalculado.picitemprecobase,
            pedido_item_quantidade: item.picitemquantidade,
            pedido_item_seq: item.picitemsequencia,
            pic_id: item.picid,
            item_pic_promocao: true,
            regra_pic: regraConsumo,
            saldo: item.picitemquantidadesaldo || 0,
            valor_total: precoPic * Number(item.picitemquantidade),
            precoComImposto: impostoItem.precoComImposto,
            valorTotalComImposto: impostoItem.precoComImposto * item.picitemquantidade,
            base_icms: impostoItem.baseIcms || 0,
            valor_icms: impostoItem.valorIcms || 0,
            natureza_operacao_id_imposto: impostoItem.naturezaoperacaoidimposto || 0,
            picitemvalorpic: precoPic,
            picitemprecobase: itemCalculado.picitemprecobase,
            picitemfaixas: itemCalculado.picitemfaixas,
            picitemdesconto: impostoItem.desconto,
            picitemfaixa: impostoItem.faixa,
            picitemquantidadetotal: itemCalculado.picitemquantidadetotal,
            picitemchave: itemCalculado.picitemchave,
          };

          novosItens.push(novoItem);
        });
        // Só substitui as promoções anteriores depois de validar e montar
        // todos os itens. Uma falha fiscal nunca pode apagar o carrinho atual.
        // Generic PIC selection intentionally replaces the previous PIC
        // selection. Inline targeted additions are additive and are merged by
        // the store using the exact PIC/SKU identity.
        if (!this.isTargeted) this.$store.commit('PedidosStore/REMOVER_ITEM_PIC_PROMOCAO');
        novosItens.forEach((novoItem) => {
          this.$store.commit('PedidosStore/ADD_OR_UPDATE_PRODUCT_ITEM_PEDIDO', novoItem);
        });
      }
    },
    quantidadeExistentePicItem(item) {
      const itens = this.$store.getters['PedidosStore/getItemPedido'] || [];
      return itens
        .filter(existing => String(existing.pic_id ?? existing.picid ?? '') === String(item.picid ?? '')
          && String(existing.item_id ?? existing.itemId ?? '') === String(item.itemid ?? item.item_id ?? '')
          && String(existing.cdn_cor ?? '') === String(item.cdn_cor ?? '')
          && String(existing.cdn_tamanho ?? '') === String(item.cdn_tamanho ?? '')
          && String(existing.cdn_embalag ?? existing.cdn_embalagem ?? '')
            === String(item.cdn_embalag ?? item.cdn_embalagem ?? ''))
        .reduce((total, existing) => total + Number(existing.pedido_item_quantidade || 0), 0);
    },
    async calcularImpostosParaItensPic(itemsPic) {
      try {
        this.impostoLoading = true;

        const clienteData = this.infoModal.type === 'info-pedido'
          ? this.GET_CLIENTE_DATA
          : this.operacaoData;

        const capaPedidoData = this.infoModal.type === 'info-pedido'
          ? this.GET_DATA_CAPA_PEDIDO
          : this.operacaoData;

        const endereco = this.infoModal.type === 'info-pedido'
          ? this.GET_ENDERECO_ENTREGA : this.operacaoData.enderecoEntrega;
        const resultados = await calcularImpostosPic(itemsPic, clienteData, capaPedidoData, endereco);
        if (resultados.some(item => item.semSimulacaoFiscal)) {
          await Swal.fire({
            icon: 'info',
            title: 'Integração TOTVS desativada',
            text: 'Será usado o preço cadastrado da promoção, sem cálculo de impostos pelo ERP.',
          });
        }
        return resultados;
      } finally {
        this.impostoLoading = false;
      }
    },
  },
  computed: {
    isTargeted() {
      return this.$store.getters['preferencias/picAtivo'] === true && this.itemFilterId != null;
    },
    targetedPicChecked() {
      return !!this.targetedPic?.checked;
    },
    targetedHasSelection() {
      return this.targetedItemsPic.some(item => item.checked);
    },
    targetedQeUnsupported() {
      return this.isTargeted
        && (this.targetedPic?.RegraConsumo || this.targetedPic?.regraConsumo
          || this.targetedPic?.regra_consumo) === 'QE';
    },
    picForDisplay() {
      if (!this.itemFilterId && !this.infoModal.picid) return this.GET_PIC;
      const itemid = this.itemFilterId == null ? null : String(this.itemFilterId);
      const picid = this.infoModal.picid == null ? null : String(this.infoModal.picid);
      const filter = list => (list || []).map(pic => ({
        ...pic,
        ...(this.isTargeted ? { checked: this.targetedPicChecked } : {}),
        ItemsPic: (this.isTargeted && this.targetedPic
          && String(pic.picid) === String(this.targetedPic.picid)
          ? this.targetedItemsPic : (pic.ItemsPic || [])).filter(item => (
          (!itemid || String(item.itemid ?? item.item_id) === itemid)
          && (!picid || String(item.picid ?? pic.picid) === picid)
        )),
      })).filter(pic => pic.ItemsPic.length > 0);
      return {
        pic_cliente: filter(this.GET_PIC.pic_cliente),
        pic_genericas: filter(this.GET_PIC.pic_genericas),
      };
    },
    ItemStore() {
      return ItemStore;
    },
    ...mapGetters('PicStore', ['GET_PIC', 'GET_LOADING', 'GET_OPERACAO_PEDIDO_PIC', 'GET_INFO_PEDIDO_PIC', 'GET_PIC_SELECTED', 'GET_PIC_SELECTED_OPERACAO']),
    ...mapGetters('InfoPedido', [
      'GET_CLIENTE_DATA',
      'GET_ENDERECO_ENTREGA',
      'GET_DATA_CAPA_PEDIDO',
    ]),
    descricaoPicSelecte() {
      return this.picSelected.picid ? this.picSelected.picdescricao : 'Selecione uma promoção';
    },
  },

  created() {
    this.$root.$on('openModal:pic', this.showModal);
  },
  destroyed() {
    this.$root.$off('openModal:pic', this.showModal);
  },
};
</script>
<style lang="scss" scoped>
.custom-control-primary {
  position: relative;
  top: -10px;
  left: 10px;
}

.checkbox-container {
  display: flex;
  align-items: center;
}

.checkbox-container input[type="checkbox"] {
  margin-right: 10px;
}

.R {
  font-size: 2rem;
}

.price {
  text-decoration: line-through;
}
</style>
